import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustBar } from "@/components/landing/TrustBar";
import { WhyApp } from "@/components/landing/WhyApp";
import { Features } from "@/components/landing/Features";
import { AiFitting } from "@/components/landing/AiFitting";
import { Catalog } from "@/components/landing/Catalog";
import { NewArrivals } from "@/components/landing/NewArrivals";
import { Benefits } from "@/components/landing/Benefits";
import { Testimonials } from "@/components/landing/Testimonials";
import { Faq } from "@/components/landing/Faq";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyCTA } from "@/components/landing/StickyCTA";
import { SocialProof } from "@/components/landing/SocialProof";
import { AccessPopup } from "@/components/landing/AccessPopup";
import { useSEO } from "@/hooks/useSEO";
import { SITE_URL } from "@/data/articlesPart1";

export default function Landing() {
  useSEO({
    title: "Angiolini — итальянские шубы: соболь, норка, шиншилла | Верхняя одежда из Италии в Алматы",
    description:
      "Angiolini — ваш персональный доступ в мир итальянской верхней одежды. Шубы из соболя, норки и шиншиллы, кашемировые пальто и пуховики из Италии в Алматы. Каталог, цены и ИИ-примерка в приложении.",
    canonical: `${SITE_URL}/`,
  });

  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <NewArrivals />
      <TrustBar />
      <WhyApp />
      <Features />
      <AiFitting />
      <Catalog />
      <Benefits />
      <Testimonials />
      <Faq />
      <FinalCTA />
      <Footer />
      <StickyCTA />
      <SocialProof />
      <AccessPopup />
    </main>
  );
}
